
<input *ngIf="mode === 'currency'"
#textfield
class="input"
[ngStyle]="styles"
type="text"
[disabled]="!editable"
[placeholder]="placeholder || ''"
[title]="placeholder || ''"
[maxlength] = "maxlength ? maxlength : 524288"
[attr.size] = "maxlength ? maxlength-1 : null"
[ngModel]="value | currency : currency : 'symbol' : format : 'de' "
(ngModel)="modelChange()"
(input)="updateValue($event)"
(focus)="onFocus($event)"
(blur)="onBlur($event)"
(keyup)="onKeyUp($event)"
[attr.disabled]="disabled ? '' : null"
/>

<input *ngIf="mode === 'float'"
#textfield
class="input"
[ngStyle]="styles"
type="text"
[disabled]="!editable"
[placeholder]="placeholder || ''"
[title]="placeholder || ''"
[maxlength] = "maxlength ? maxlength : 524288"
[attr.size] = "maxlength ? maxlength : null"
[ngModel]="value | number : format : 'de' " 
(ngModel)="modelChange()"
(input)="updateValue($event)"
(focus)="onFocus($event)"
(blur)="onBlur($event)"
(keyup)="onKeyUp($event)"
[attr.disabled]="disabled ? '' : null"
/>

<input *ngIf="mode !== 'currency' && mode !== 'float'"
#textfield
class="input"
[ngStyle]="styles"
type="text"
[placeholder]="placeholder || ''"
[title]="placeholder || ''"
[maxlength] = "maxlength ? maxlength : 524288"
[attr.size] = "maxlength ? maxlength : null"
[ngModel]="value" 
(ngModel)="modelChange()"
(input)="updateValue($event)"
(focus)="onFocus($event)"
(blur)="onBlur($event)"
(keyup)="onKeyUp($event)"
[attr.disabled]="disabled ? '' : null"
/>
